export default __webpack_public_path__ + "static/media/Laval-fam-MTL-Gazette.9790a61e.jpg";